import React from "react"
import { FormQuestion, QuestionTypes } from "sharedTypes"
import BarChart from "pages/EventShow/Submissions/ResponseChart/BarChart"
import PieChart from "./PieChart"

type Props = {
  question: FormQuestion
}

const Chart = ({ question }: Props) => {
  switch (question.type) {
    case QuestionTypes.SingleLineText:
    case QuestionTypes.ParagraphText:
    case QuestionTypes.FileUpload:
      return null
    case QuestionTypes.MultipleAnswer:
    case QuestionTypes.Terms:
      return <BarChart question={question} />
    default:
      return <PieChart question={question} />
  }
}

export default Chart
